import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// This static object maps category names from your backend to images for the UI.
const categoryVisuals = {
    Motivation: { image: 'https://images.unsplash.com/photo-1599423300658-c4d621743859?q=80&w=870&auto=format&fit=crop' },
    "Quick Tips": { image: 'https://images.unsplash.com/photo-1516321497487-e288fb19713f?q=80&w=870&auto=format&fit=crop' },
    Mindfulness: { image: 'https://images.unsplash.com/photo-1474418397713-7e15e4d5e154?q=80&w=870&auto=format&fit=crop' },
    Fitness: { image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=870&auto=format&fit=crop' },
    Default: { image: 'https://images.unsplash.com/photo-1611162616475-46b6352b99bf?q=80&w=774&auto=format&fit=crop' }
};

const Reels = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const apiUrl = '/api/summary/reels_counts_cat';

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const formattedCategories = data.map(cat => ({
          ...cat, // Contains 'category' and 'count' from backend
          image: categoryVisuals[cat.category]?.image || categoryVisuals.Default.image
        }));
        setCategories(formattedCategories);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching reel categories:', error);
        setError(error.message);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <p className="text-center p-4">Loading categories...</p>;
  if (error) return <p className="error-message p-4">Error: {error}</p>;

  return (
    <div className="category-grid">
      {categories.map((category, index) => (
        <Link to={`/reels/category/${category.category}`} key={index} className="category-card-link">
          <div className="category-card" style={{ backgroundImage: `url(${category.image})` }}>
            <div className="category-card-overlay">
              <h3 className="category-card-title">{category.category} ({category.count})</h3>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Reels;
